import UiForm from "./UiForm";
import MiezzListItem from "@/models/MiezzListItem";
import { EnumPipe } from "@/models/EnumPipe";
import { EnumMiezzFormItemType, MiezzFormItem } from "@/models/MiezzForm";
import UiGroup from "./UiGroup";

/**
 * 
 * @description 自动生成的代码,请勿修改
 */
export default class DtoFormOrderCost extends UiForm<string> {
    constructor() {
        //无参构造函数
        super()
        this.UnitPrice = 0;
        this.TotalPrice = 0;
        this.UiGroups = [];
    }

    [proName: string]: any;
    /**
     * 费用名称
     */
    CostId?: string;
    /**
     * 费用名称
     */
    CostLabel?: string;
    /**
     * 币制
     */
    CurrencySystemId?: string;
    /**
     * 币制
     */
    CurrencySystemLabel?: string;
    /**
     * 单价
     */
    UnitPrice?: number;
    /**
     * 税率%
     */
    TaxRate?: number;
    /**
     * 计价单位
     */
    FirstChargingUnitId?: string;
    /**
     * 计价单位
     */
    FirstChargingUnitLabel?: string;
    /**
     * 数量
     */
    FirstChargingNumber?: number;
    /**
     * 税额
     */
    TaxAmount?: number;
    /**
     * 单项合计
     */
    TotalPrice?: number;
    /**
     * 备注
     */
    Remark?: string;
}

/**
 * -表单校验
 */
export const DtoFormOrderCostRules = {
    CostId: [
        {
            required: true,
            message: "信息不能为空",
            trigger: "change",
        },
    ],
    CurrencySystemId: [
        {
            required: true,
            message: "信息不能为空",
            trigger: "change",
        },
    ],
    UnitPrice: [
        {
            required: true,
            message: "信息不能为空",
            trigger: "change",
        },
    ],
    FirstChargingUnitId: [
        {
            required: true,
            message: "信息不能为空",
            trigger: "change",
        },
    ],
    Remark: [
        {
            max: 10240,
            message: "文本长度不能超过 10240 个字符",
            trigger: "blur",
        },
    ],
}

/**
 * -设置项
 */
export const DtoFormOrderCostMiezzListItems: MiezzListItem[]  = [
  {
    Prop: "CostId",
    Label: "费用名称",
    Customize: true,
  },
  {
    Prop: "CurrencySystemId",
    Label: "币制",
    Customize: true,
  },
  {
    Prop: "UnitPrice",
    Label: "单价",
    Customize: true,
  },
  {
    Prop: "TaxRate",
    Label: "税率%",
    Customize: true,
  },
  {
    Prop: "FirstChargingUnitId",
    Label: "计价单位",
    Customize: true,
  },
  {
    Prop: "FirstChargingNumber",
    Label: "数量",
    Customize: true,
  },
  {
    Prop: "TaxAmount",
    Label: "税额",
    Customize: true,
  },
  {
    Prop: "TotalPrice",
    Label: "单项合计",
    Customize: true,
  },
  {
    Prop: "Remark",
    Label: "备注",
    Customize: true,
  },
]

/**
 * -设置项
 */
export const DtoFormOrderCostMiezzFormItems: MiezzFormItem[] = [
  {
    Prop: "CostId",
    Label: "费用名称",
    Customize: true,
  },
  {
    Prop: "CurrencySystemId",
    Label: "币制",
    Customize: true,
  },
  {
    Prop: "UnitPrice",
    Label: "单价",
    Customize: true,
  },
  {
    Prop: "TaxRate",
    Label: "税率%",
    Customize: true,
  },
  {
    Prop: "FirstChargingUnitId",
    Label: "计价单位",
    Customize: true,
  },
  {
    Prop: "FirstChargingNumber",
    Label: "数量",
    Customize: true,
  },
  {
    Prop: "TaxAmount",
    Label: "税额",
    Customize: true,
  },
  {
    Prop: "TotalPrice",
    Label: "单项合计",
    Customize: true,
  },
  {
    Prop: "Remark",
    Label: "备注",
    Customize: true,
  },
]
